import { MoveRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ExploreAddOns = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div>
      <div className="container px-20 pt-10">
        <div>
          <h2 className="text-center font-bold text-3xl my-5">
            {t("exploreAddOns")}
          </h2>
          <p className="text-center text-gray-500 my-3">
            {t("exploreAddOnsDescription")}
          </p>
          <div>
            <h3 className="font-bold my-5">{t("operationalControlScaling")}</h3>
            <div className="space-y-10">
              <div className="grid grid-cols-3 gap-10">
                <div className="flex gap-3 flex-col bg-[#F7F7FF] rounded-md py-3 px-5">
                  <div className="flex gap-3 items-center mt-3">
                    👥
                    <h4 className="font-bold text-lg">{t("additionalUser")}</h4>
                  </div>
                  <p className="my-5 text-gray-500">
                    {t("additionalUserDescription")}
                  </p>
                  <button className="flex gap-3 my-3">
                    <span className="hover:border py-2 px-3 rounded-md transition hover:bg-white hover:shadow-md flex gap-3">
                      <span onClick={() => navigate("/addOns/AdditionalUsers")}>
                        {t("learnMore")}{" "}
                      </span>
                      <MoveRight />
                    </span>
                  </button>
                </div>

                <div className="flex gap-3 flex-col bg-[#F7F7FF] rounded-md py-3 px-5">
                  <div className="flex gap-3 items-center mt-3">
                    🔐
                    <h4 className="font-bold text-lg">
                      {t("permissionSettings")}
                    </h4>
                  </div>
                  <p className="my-5 text-gray-500">
                    {t("permissionSettingsDescription")}
                  </p>
                  <button className="flex gap-3 my-3">
                    <span className="hover:border py-2 px-3 rounded-md transition hover:bg-white hover:shadow-md flex gap-3">
                      <span
                        onClick={() => navigate("/addOns/PermissionSettings")}
                      >
                        {t("learnMore")}{" "}
                      </span>
                      <MoveRight />
                    </span>
                  </button>
                </div>

                <div className="flex gap-3 flex-col bg-[#F7F7FF] rounded-md py-3 px-5">
                  <div className="flex gap-3 items-center mt-3">
                    <h4 className="font-bold text-lg">
                      🏪 {t("multiLocationsManagement")}
                    </h4>
                  </div>
                  <p className="my-5 text-gray-500">
                    {t("multiLocationsManagementDesc")}
                  </p>
                  <button className="flex gap-3 my-3">
                    <span className="hover:border py-2 px-3 rounded-md transition hover:bg-white hover:shadow-md flex gap-3">
                      <span onClick={() => navigate("/addOns/MultiLocations")}>
                        {t("learnMore")}{" "}
                      </span>
                      <MoveRight />
                    </span>
                  </button>
                </div>
              </div>

              <div className="grid grid-cols-3 gap-10">
                <div className="flex gap-3 flex-col bg-[#F7F7FF] rounded-md py-3 px-5">
                  <div className="flex gap-3 items-center mt-3">
                    <h4 className="font-bold text-lg">
                      🔎 {t("searchOptimization")}
                    </h4>
                  </div>
                  <p className="my-5 text-gray-500">
                    {t("searchOptimizationDesc")}
                  </p>
                  <button className="flex gap-3 my-3">
                    <span className="hover:border py-2 px-3 rounded-md transition hover:bg-white hover:shadow-md flex gap-3">
                      <span
                        onClick={() => navigate("/addOns/SearchOptimization")}
                      >
                        {t("learnMore")}{" "}
                      </span>
                      <MoveRight />
                    </span>
                  </button>
                </div>
                <div className="col-span-2 rounded-md bg-gray-300"></div>
              </div>
            </div>
          </div>

          <div>
            <h3 className="py-10 font-bold text-lg">
              {t("engagementLoyalty")}
            </h3>
            <div className="space-y-10">
              <div className="grid grid-cols-3 gap-10">
                <div className="flex gap-3 flex-col bg-[#F7F7FF] rounded-md py-3 px-5">
                  <div className="flex gap-3 items-center mt-3">
                    🎁
                    <h4 className="font-bold text-lg">
                      {t("stampsPointsLoyaltySystem")}
                    </h4>
                  </div>
                  <p className="my-5 text-gray-500">
                    {t("stampsPointsLoyaltySystemDesc")}
                  </p>
                  <button className="flex gap-3 my-3">
                    <span className="hover:border py-2 px-3 rounded-md transition hover:bg-white hover:shadow-md flex gap-3">
                      <span onClick={() => navigate("/addOns/StampsLoyalty")}>
                        {t("learnMore")}{" "}
                      </span>
                      <MoveRight />
                    </span>
                  </button>
                </div>
                <div className="flex gap-3 flex-col bg-[#F7F7FF] rounded-md py-3 px-5">
                  <div className="flex gap-3 items-center mt-3">
                    🎨
                    <h4 className="font-bold text-lg">
                      {t("customizedDesign")}
                    </h4>
                  </div>
                  <p className="my-5 text-gray-500">
                    {t("customizedDesignDesc")}
                  </p>
                  <button className="flex gap-3 my-3">
                    <span className="hover:border py-2 px-3 rounded-md transition hover:bg-white hover:shadow-md flex gap-3">
                      <span
                        onClick={() =>
                          navigate("/addOns/CustomizedDesignStamps")
                        }
                      >
                        {t("learnMore")}{" "}
                      </span>
                      <MoveRight />
                    </span>
                  </button>
                </div>
                <div className="flex gap-3 flex-col bg-[#F7F7FF] rounded-md py-3 px-5">
                  <div className="flex gap-3 items-center mt-3">
                    💳
                    <h4 className="font-bold text-lg">
                      {t("cardsGiftCardsPrepaidLoyalty")}
                    </h4>
                  </div>
                  <p className="my-5 text-gray-500">
                    {t("cardsGiftCardsPrepaidLoyaltyDesc")}
                  </p>
                  <button className="flex gap-3 my-3">
                    <span className="hover:border py-2 px-3 rounded-md transition hover:bg-white hover:shadow-md flex gap-3">
                      <span onClick={() => navigate("/addOns/GiftCard")}>
                        {t("learnMore")}{" "}
                      </span>
                      <MoveRight />
                    </span>
                  </button>
                </div>
              </div>

              <div className="grid grid-cols-3 gap-10">
                <div className="flex gap-3 flex-col bg-[#F7F7FF] rounded-md py-3 px-5">
                  <div className="flex gap-3 items-center mt-3">
                    📣
                    <h4 className="font-bold text-lg">
                      {t("socialMediaEngagement")}
                    </h4>
                  </div>
                  <p className="my-5 text-gray-500">
                    {t("socialMediaEngagementDesc")}
                  </p>
                  <button className="flex gap-3 my-3">
                    <span className="hover:border py-2 px-3 rounded-md transition hover:bg-white hover:shadow-md flex gap-3">
                      <span onClick={() => navigate("/addOns/SocialMediaA")}>
                        {t("learnMore")}{" "}
                      </span>
                      <MoveRight />
                    </span>
                  </button>
                </div>

                <div className="flex gap-3 flex-col bg-[#F7F7FF] rounded-md py-3 px-5">
                  <div className="flex gap-3 items-center mt-3">
                    📱
                    <h4 className="font-bold text-lg">
                      {t("interactiveAdvertisement")}
                    </h4>
                  </div>
                  <p className="my-5 text-gray-500">
                    {t("interactiveAdvertisementDesc")}
                  </p>
                  <button className="flex gap-3 my-3">
                    <span className="hover:border py-2 px-3 rounded-md transition hover:bg-white hover:shadow-md flex gap-3">
                      <span
                        onClick={() =>
                          navigate("/addOns/InteractiveAdvertisement")
                        }
                      >
                        {t("learnMore")}{" "}
                      </span>
                      <MoveRight />
                    </span>
                  </button>
                </div>

                <div className="flex-1 rounded-md bg-gray-300">
                  <img
                    src="https://i.pinimg.com/736x/5a/1c/a7/5a1ca7c49f088953bc362750615a3150.jpg"
                    alt={t("engagementIllustration")}
                    className="rounded-md h-full w-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>

          <div>
            <h3 className="py-10 font-bold text-lg">
              {t("advancedManagement")}
            </h3>
            <div className="space-y-10">
              <div className="grid grid-cols-3 gap-10">
                <div className="flex gap-3 flex-col bg-[#F7F7FF] rounded-md py-3 px-5">
                  <div className="flex gap-3 items-center mt-3">
                    🛒
                    <h4 className="font-bold text-lg">
                      {t("orderManagement")}
                    </h4>
                  </div>
                  <p className="my-5 text-gray-500">
                    {t("orderManagementDesc")}
                  </p>
                  <button className="flex gap-3 my-3">
                    <span className="hover:border py-2 px-3 rounded-md transition hover:bg-white hover:shadow-md flex gap-3">
                      <span onClick={() => navigate("/addOns/OrderManagement")}>
                        {t("learnMore")}{" "}
                      </span>
                      <MoveRight />
                    </span>
                  </button>
                </div>

                <div className="flex gap-3 flex-col bg-[#F7F7FF] rounded-md py-3 px-5">
                  <div className="flex gap-3 items-center mt-3">
                    📌
                    <h4 className="font-bold text-lg">{t("reservations")}</h4>
                  </div>
                  <p className="my-5 text-gray-500">{t("reservationsDesc")}</p>
                  <button className="flex gap-3 my-3">
                    <span className="hover:border py-2 px-3 rounded-md transition hover:bg-white hover:shadow-md flex gap-3">
                      <span onClick={() => navigate("/addOns/Reservations")}>
                        {t("learnMore")}{" "}
                      </span>
                      <MoveRight />
                    </span>
                  </button>
                </div>
                <div className="flex gap-3 flex-col bg-[#F7F7FF] rounded-md py-3 px-5">
                  <div className="flex gap-3 items-center mt-3">
                    👤
                    <h4 className="font-bold text-lg">
                      {t("customerManagement")}
                    </h4>
                  </div>
                  <p className="my-5 text-gray-500">
                    {t("customerManagementDesc")}
                  </p>
                  <button className="flex gap-3 my-3">
                    <span className="hover:border py-2 px-3 rounded-md transition hover:bg-white hover:shadow-md flex gap-3">
                      <span
                        onClick={() => navigate("/addOns/CustomerManagement")}
                      >
                        {t("learnMore")}{" "}
                      </span>
                      <MoveRight />
                    </span>
                  </button>
                </div>
              </div>

              <div className="grid grid-cols-3 gap-10">
                <div className="flex gap-3 flex-col bg-[#F7F7FF] rounded-md py-3 px-5">
                  <div className="flex gap-3 items-center mt-3">
                    📊
                    <h4 className="font-bold text-lg">
                      {t("analyticalDashboard")}
                    </h4>
                  </div>
                  <p className="my-5 text-gray-500">
                    {t("analyticalDashboardDesc")}
                  </p>
                  <button className="flex gap-3 my-3">
                    <span className="hover:border py-2 px-3 rounded-md transition hover:bg-white hover:shadow-md flex gap-3">
                      <span
                        onClick={() => navigate("/addOns/AnalyticalDashboard")}
                      >
                        {t("learnMore")}{" "}
                      </span>
                      <MoveRight />
                    </span>
                  </button>
                </div>

                <div className="flex gap-3 flex-col bg-[#F7F7FF] rounded-md py-3 px-5">
                  <div className="flex gap-3 items-center mt-3">
                    📱
                    <h4 className="font-bold text-lg">
                      {t("customizedMenuQR")}
                    </h4>
                  </div>
                  <p className="my-5 text-gray-500">
                    {t("customizedMenuQRDesc")}
                  </p>
                  <button className="flex gap-3 my-3">
                    <span className="hover:border py-2 px-3 rounded-md transition hover:bg-white hover:shadow-md flex gap-3">
                      <span
                        onClick={() => navigate("/addOns/CustomizedMenuQR")}
                      >
                        {t("learnMore")}{" "}
                      </span>
                      <MoveRight />
                    </span>
                  </button>
                </div>

                <div className="flex-1 rounded-md bg-gray-300">
                  <img
                    src="https://i.pinimg.com/736x/04/e4/b6/04e4b67b5b8346290a60acae79136f6b.jpg"
                    alt={t("advancedManagementIllustration")}
                    className="rounded-md w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExploreAddOns;
